module.exports = __webpack_public_path__ + "img/76.4.NH3-N.32371446.png";